'use strict';

export default class ChampsController
{
	/*@ngInject*/
	constructor($http, $stateParams)
	{
		this.$http = $http;
		this.currentPage = 1;
		this.pageSize = 11;
		this.PageChanged();
	}
	
	PageChanged()
	{
		this.champsPromise = this.$http.post("/api/frontend/champs/" + this.currentPage + "/" + this.pageSize, this.filter)
		.then(response => {
			this.champs = response.data;
			this.total = this.champs.length > 0 ? this.champs[0].total : 0;
		});
	}

	DoSearch(form)
	{
		this.filter = {
			filter: this.nameFilter,
			clubs: this.selectedClubs.map(function(x) {return x.id;}),
			classes: this.selectedClasses.map(function(x) {return x.id;}),
			years: this.selectedYears.map(function(x) {return x.year;})
		};

		this.currentPage = 1;
		this.PageChanged();
	}
}



// WEBPACK FOOTER //
// ./client/app/frontend/champs/champs.controller.js